import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from '../../../../util/reactIntl';
import { NamedLink } from '../../../../components';
import css from './OwnerAboutEmptyIntroductionCard.module.css';

const OwnerAboutEmptyIntroductionCard = ({ storeName, className }) => (
  <div className={classNames(css.card, className)}>
    <h3 className={css.title}>
      <>
        <FormattedMessage
          id="StoreProfilePage.tabs.about.title"
          defaultMessage="About"
        />
        &nbsp;{storeName}
      </>
    </h3>

    <div className={css.contentWrapper}>
      <div className={css.iconWrapper}>
        <i className="ri-file-text-line" aria-hidden />
      </div>
      <p className={css.description}>
        <FormattedMessage
          id="StoreProfilePage.about.emptyIntro.description"
          defaultMessage="Add a short introduction to tell customers what your store offers."
        />
      </p>
      <NamedLink name="StoreBasicInformationPage" className={css.ctaLink}>
        <FormattedMessage
          id="StoreProfilePage.about.emptyIntro.cta"
          defaultMessage="Add Store Introduction"
        />
        <i className={classNames('ri-arrow-right-up-line', css.ctaArrow)} aria-hidden />
      </NamedLink>
    </div>
  </div>
);

OwnerAboutEmptyIntroductionCard.propTypes = {
  storeName: PropTypes.node,
  className: PropTypes.string,
};

export default OwnerAboutEmptyIntroductionCard;
